export function collectRecommendedVideoIds(feedIndex, recommendedPath) {
    if (feedIndex !== 0 || !recommendedPath) {
        return null;
    }
    const ids = new Set();
    const { recommended_videos } = recommendedPath;
    // Watched videos now stay in `recommended_videos` with `progress` >= 100
    // and `watched_at` set, so the prior `completed_videos` collation is no
    // longer needed.
    (recommended_videos || []).forEach((v) => v?.video_id && ids.add(v.video_id));
    return ids.size > 0 ? ids : null;
}
